import axios from "axios";
import { endpoints } from "../_config";
import { getUserTokenFromStorage } from "../_config/helper.config";

class VerificationService {
  static async checkForMobileExisting(mobile) {
    return axios
      .post(
        endpoints.user.verify.checkExistingMobile,
        {
          mobile,
        },
        {
          headers: {
            Authorization: "Bearer " + getUserTokenFromStorage(),
          },
        }
      )
      .then((res) => res.data);
  }
  static async checkForEmailExisting(email) {
    return axios
      .post(
        endpoints.user.verify.checkExistingEmail,
        {
          email,
        },
        {
          headers: {
            Authorization: "Bearer " + getUserTokenFromStorage(),
          },
        }
      )
      .then((res) => res.data);
  }
}

export { VerificationService };
